import Block from "../Block";
import "./BlockScenario.css";
import BlockChild from "../BlockChild/BlockChild";
import imageScenarioPreview from "/src/features/editor/image/scenario_preview.png";
import Menu from "../Menu/Menu";

function BlockScenario({object_id, name, x, y, data, lowVersion, children, type}) {
    // scenario block
    const block = {
        name, x, y, id : object_id, imageLow : imageScenarioPreview, lowVersion, type, data, className : "scenario", childrenBlocks : children
    }

    // lowVersion no information are action on the block, an image will be display if lowVersion
    if(children == undefined) {
        console.log(`block ${object_id} without children`)
        return <></>;
    }
    return (
        <Block {...block}>
            {
            !lowVersion && 
                <>
                <Menu className="scenario" id={object_id} deletable={!data.basic}/>
                <div className="block_scenario_icon"></div>
                <label className="block_scenario_title">{name}</label>
                <BlockChild className="scenario" style={{left: "185.5px", top: "-130px", transform: "rotate(270deg)"}} parent_block_id={object_id} object_id={children[0].object_id} zero={true}/>
                </>
            }
        </Block>
    )
}

export default BlockScenario;